import React, { Fragment, useMemo } from "react";

import ShyftPassTemplate from "@/components/Templates/ShyftPassTemplate";
import HeroSection from "@/containers/ShyftPassBookClass/HeroSection";
import SessionCard from "@/containers/ShyftPassBooking/ScheduleSection/SessionCard";
import FAQSection from "@/containers/ShyftPassPage/FAQSection";

import { useAppSelector } from "@/hooks";
import Typography from "@/foundation/Typography/V2";

import { mapClassList } from "../ShyftPassPage/WorkoutScheduleSection/mapWorkoutScheduleData";

import styles from "./ShyftPassClassListPage.module.scss";

const ShyftPassClassListPage = ({ h1Tag }) => {
  const { classList, classListError } =
    useAppSelector((state) => state.shyftPass) || {};

  const data = useMemo(() => {
    if (!Object.keys(classList)?.length) return [];
    return mapClassList(classList);
  }, [classList]);

  return (
    <ShyftPassTemplate hideFooter={true}>
      <div className={styles.bookClassContainer}>
        {h1Tag && <h1 style={{ display: "none" }}>{h1Tag}</h1>}
        <HeroSection h1Tag={h1Tag} />
        <div className="session-card-section">
          {classListError || classList?.center_timings?.length === 0 ? (
            <Typography
              variant="routelink2"
              to="/shyftpass"
              className={styles.noClassFound}
            >
              {`We don't have any sessions ${
                !classListError ? `of ${classList?.h1_heading} ` : ""
              }in the next couple of weeks. Click here to see the running schedule of all Shyft Pass workouts!`}
            </Typography>
          ) : (
            data?.map((sessionData, index) => (
              <Fragment key={index}>
                {index !== 0 && <hr style={{ width: "100%" }} />}
                <SessionCard isClassListPurchasePage {...sessionData} />
              </Fragment>
            ))
          )}
        </div>
        <div className={styles.faqs}>
          <FAQSection />
        </div>
      </div>
    </ShyftPassTemplate>
  );
};

export default ShyftPassClassListPage;
